import React, { useEffect, useState } from "react";
import Title from "../../../components/common/Title";
import { Topbar } from "../../../components/include/Topbar";
// import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { Postdata } from "../../../helpers/api.service";
import HttpService from "../../../helpers/httpServices";
// import { message } from "../../../redux/actions/toastActions";
import Loader from "../../../components/common/Loader";
import emailIcon from "../../../assets/Icons/email.svg";
import lockIcon from "../../../assets/Icons/lock.svg";
import userIcon from "../../../assets/Icons/user.svg";
// import schoolIcon from "../../../assets/Icons/graduate.svg";
import phoneIcon from "../../../assets/Icons/world.svg";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import { toast } from "sonner";
import { useCountryNavigate } from "../../../components/common/UseCountryNavigate";
import axios from "axios";

const AddAdmin = () => {
  // const schoolName = useSelector(state => state.auth.data.user.school_id.name) || "";
  // const temp = useSelector((state) => state.auth.data);
  // console.log("schoolName>>> ****", temp)
  // const user = useSelector((state) => state.auth.data.user);

  const [data, setData] = useState({
    first_name: "",
    last_name: "",
    username: "",
    school_name: "",
    email: "",
    mobile: "",
    password: "",
    isAgreeTC: true,
    school_role_id: null,
    country_code: "KE",
  });
  // const dispatch = useDispatch();
  // const navigate = useNavigate();
  const navigate = useCountryNavigate();
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loader, setLoader] = useState(false);
  const [roles, setRoles] = useState([]);
  const [errors, setErrors] = useState({});
  // const [refresh, setRefresh] = useState(false);
  const location = useLocation();
  const params = useParams();
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const ALLOWED_COUNTRY_CODES = ["ke", "ug"];
  const [selectedCountry, setSelectedCountry] = useState("KE");
  const [countries, setCountries] = useState([]);
  const [countryOpen, setCountryOpen] = useState(false);
  const flagsContext = require.context(
    "../../../assets/flags",
    false,
    /\.(png|jpe?g|svg)$/,
  );

  const getFlagImage = (code) => {
    try {
      return flagsContext(`./${code.toLowerCase()}.png`);
    } catch {
      return null;
    }
  };

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const res = await axios.get(HttpService.school_country_show);

        if (res.status === 200 && Array.isArray(res.data.data)) {
          const activeCountries = res.data.data
            .filter(
              (c) =>
                c.isActive === true &&
                ALLOWED_COUNTRY_CODES.includes(c.code.toLowerCase()),
            )
            .sort((a, b) => (a.code.toLowerCase() === "ke" ? -1 : 1));
          setCountries(activeCountries);
        }
      } catch (err) {
        console.error("Error loading countries:", err);
      }
    };

    fetchCountries();
  }, []);
  const validate = () => {
    let tempErrors = {};

    if (!data.first_name?.trim()) {
      tempErrors.first_name = "First name is required";
    } else if (!/^[A-Za-z\s]+$/.test(data.first_name.trim())) {
      tempErrors.first_name =
        "First name should only contain letters and spaces";
    }

    if (!data.last_name?.trim()) {
      tempErrors.last_name = "Last name is required";
    } else if (!/^[A-Za-z\s]+$/.test(data.last_name.trim())) {
      tempErrors.last_name = "Last name should only contain letters and spaces";
    }

    if (!data.username?.trim()) {
      tempErrors.username = "Username is required";
    } else if (!/^(?=.*[A-Za-z])[A-Za-z0-9]+$/.test(data.username)) {
      tempErrors.username =
        "Username must contain at letter and can include numbers.";
    }

    if (!data.email?.trim()) {
      tempErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(data.email)) {
      tempErrors.email = "Enter a valid email address";
    }

    if (!data.mobile?.trim()) {
      tempErrors.mobile = "Contact number is required";
    } else if (!/^\d{10}$/.test(data.mobile.trim())) {
      tempErrors.mobile = "Enter a valid 10-digit contact number";
    }

    const strongPasswordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$!%&*])[A-Za-z\d@#$!%&*]{6,12}$/;

    if (!params.id && !data.password?.trim()) {
      tempErrors.password = "Password is required";
    } else if (!params.id && !strongPasswordRegex.test(data.password)) {
      tempErrors.password =
        "Password must be 8–12 characters, with one uppercase , one lowercase , one number &  one special character.";
    }

    if (
      params.id &&
      data.password?.trim() &&
      !strongPasswordRegex.test(data.password)
    ) {
      tempErrors.password =
        "Password must be 8–12 characters, with one uppercase , one lowercase , one number &  one special character.";
    }

    if (!params.id && !confirmPassword?.trim()) {
      tempErrors.confirmPassword = "Confirm password is required";
    } else if (!params.id && confirmPassword !== data.password) {
      tempErrors.confirmPassword = "Passwords do not match";
    }

    if (
      params.id &&
      data.password?.trim() &&
      (!confirmPassword?.trim() || confirmPassword !== data.password)
    ) {
      tempErrors.confirmPassword = "Passwords do not match";
    }

    if (!data.school_role_id) {
      tempErrors.school_role_id = "Role selection is required";
    }

    setErrors(tempErrors);

    return Object.keys(tempErrors).length === 0;
  };

  const fetchRoles = () => {
    setLoader(true);
    Postdata(HttpService.school_role_list).then((res) => {
      if (res.status == 200) {
        setRoles(res.data);
      } else {
        toast.error(res.message || "Failed to fetch roles");
      }
      setLoader(false);
    }).catch(err => {
      const errorMsg = err.response?.data?.message || err.message || "Failed to fetch roles";
      toast.error(errorMsg);
      setLoader(false);
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log("Submitting form...");
    if (!validate()) {
      toast.error("Please correct the highlighted errors.");
      return;
    }
    setLoader(true);
    let form = new FormData();
    if (params.id) {
      form.append("id", params.id);
    }
    form.append("first_name", data.first_name);
    form.append("last_name", data.last_name);
    form.append("username", data.username);
    // form.append("school_name", data.school_name)
    form.append("email", data.email);
    form.append("mobile", data.mobile);
    form.append("password", data.password);
    form.append("isAgreeTC", data.isAgreeTC);
    form.append("school_role_id", data.school_role_id);
    form.append("country_code", data.country_code);
    console.log("form:::::::::::::: ", form);
    Postdata(HttpService.school_subadmin_add, form)
      .then((res) => {
        if (res.status == 200) {
          toast.success(res.message);
          navigate("admin-subadmin");
        } else {
          toast.error(res.message || "Something went wrong");
        }
        setLoader(false);
      })
      .catch((error) => {
        const errorMsg = error.response?.data?.message || error.message || "An error occurred";
        toast.error(errorMsg);
        setLoader(false);
      });
  };

  // const fetchData = () => {
  //   setLoader(true);
  //   Postdata(HttpService.school_subadmin_show, { id: params.id }).then(
  //     (res) => {
  //       if (res.status == 200) {
  //         setData({
  //           first_name: res.data.first_name,
  //           last_name: res.data.last_name,
  //           username: res.data.username,
  //           // school_name: schoolName ?? "",
  //           email: res.data.email,
  //           mobile: res.data.mobile,
  //           isAgreeTC: res.data.isAgreeTC,
  //           school_role_id: res.data.school_role_id,
  //           country_code: res.data.country_code || "KE",
  //         });
  //       }
  //       // else {

  //       //     dispatch(message(res.message));
  //       // }
  //       setLoader(false);
  //     }
  //   );
  // };

  const fetchData = () => {
    setLoader(true);
    Postdata(HttpService.school_subadmin_show, { id: params.id }).then(
      (res) => {
        if (res.status === 200) {
          setData({
            first_name: res.data.first_name,
            last_name: res.data.last_name,
            username: res.data.username,
            email: res.data.email,
            mobile: res.data.mobile,
            isAgreeTC: res.data.isAgreeTC,
            school_role_id: res.data.school_role_id,
            country_code: res.data.country_code || "KE",
          });
        } else {
          toast.error(res.message || "Failed to fetch admin details");
        }
        setLoader(false);
      },
    ).catch(err => {
      const errorMsg = err.response?.data?.message || err.message || "Failed to fetch admin details";
      toast.error(errorMsg);
      setLoader(false);
    });
  };
  useEffect(() => {
    fetchRoles();
    if (params.id) {
      fetchData();
    }
  }, []);

  if (loader) {
    return <Loader isClass="loader_fullscreen" />;
  }
  return (
    <>
      <Title name="Admin Management" />
      <Topbar
        title={
          location.state?.type == "edit"
            ? "Edit Adminstrator"
            : "Add Adminstrator"
        }
        aerrow={true}
      />
      <div className="p-6 space-y-6 pr-0">
        <form className="login-form" autoComplete="off" onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
            <div>
              <label>
                First Name<span className="required">*</span>
              </label>
              <div className="input-group">
                <span className="icon">
                  <img src={userIcon} alt="user icon" />
                </span>
                <input
                  type="text"
                  autoComplete="new-first_name"
                  value={data.first_name}
                  onChange={(e) =>
                    setData({ ...data, first_name: e.target.value })
                  }
                  placeholder="Enter First Name"
                />
              </div>
              {errors.first_name && (
                <p className="text-red-500 text-xs mt-1">{errors.first_name}</p>
              )}
            </div>
            <div>
              <label>
                Last Name<span className="required">*</span>
              </label>
              <div className="input-group">
                <span className="icon">
                  <img src={userIcon} alt="user icon" />
                </span>
                <input
                  type="text"
                  autoComplete="new-last_name"
                  value={data.last_name}
                  onChange={(e) =>
                    setData({ ...data, last_name: e.target.value })
                  }
                  placeholder="Enter Last Name"
                />
              </div>
              {errors.last_name && (
                <p className="text-red-500 text-xs mt-1">{errors.last_name}</p>
              )}
            </div>
            {/* Username */}
            <div>
              <label>
                Username<span className="required">*</span>
              </label>
              <div className="input-group">
                <span className="icon">
                  <img src={userIcon} alt="user icon" />
                </span>
                <input
                  type="text"
                  autoComplete="new-username"
                  value={data.username}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
                    setData({ ...data, username: value });
                  }}
                  placeholder="Enter Your Username"
                />
              </div>
              {errors.username && (
                <p className="text-red-500 text-xs mt-1">{errors.username}</p>
              )}
            </div>

            {/* Email ID */}
            <div>
              <label>
                Email ID<span className="required">*</span>
              </label>
              <div className="input-group">
                <span className="icon">
                  <img src={emailIcon} alt="email icon" />
                </span>
                <input
                  type="text"
                  value={data.email}
                  autoComplete="new-email"
                  // onChange={(e) => setData({ ...data, email: e.target.value })}
                  onChange={(e) => {
                    let value = e.target.value;

                    // Allow only alphanumeric, @ and .
                    const validChars = /^[a-zA-Z0-9@.]*$/;

                    // Count of @
                    const atCount = (value.match(/@/g) || []).length;

                    if (validChars.test(value) && atCount <= 1) {
                      setData({ ...data, email: value });
                    }
                  }}
                  placeholder="Enter Your Email ID"
                />
              </div>
              {errors.email && (
                <p className="text-red-500 text-xs mt-1">{errors.email}</p>
              )}
            </div>
            {/* Contact Number */}
            {/* <div>

                            <label>
                                Contact Number<span className="required">*</span>
                            </label>
                            <div className="input-group">
                                <span className="icon">
                                    <img src={phoneIcon} alt="phone icon" />
                                </span>
                                <input
                                    type="tel"
                                    value={data.mobile}
                                    autoComplete='new-mobile'
                                    // onChange={(e) => setData({ ...data, mobile: e.target.value })}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        if (/^\d{0,9}$/.test(val)) {
                                            setData({ ...data, mobile: val });
                                        }
                                    }}
                                    placeholder="Enter Your Contact Number"

                                />
                            </div>
                            {errors.mobile && <p className="text-red-500 text-xs mt-1">{errors.mobile}</p>}

                        </div> */}
            {/* country with the flags  xs*/}
            {/* Contact Number */}

            <div>
              <label>
                Contact Number<span className="required">*</span>
              </label>

              <div className="input-group" style={{ position: "relative" }}>
                {/* FLAG BUTTON */}
                <span
                  className="icon cursor-pointer"
                  onClick={() => setCountryOpen((prev) => !prev)}
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                >
                  <img
                    src={
                      data.country_code
                        ? getFlagImage(data.country_code)
                        : phoneIcon
                    }
                    alt="flag"
                    style={{ width: "20px", height: "14px" }}
                  />

                  <svg width="12" height="12" viewBox="0 0 12 12">
                    <path
                      d="M3 4.5L6 7.5L9 4.5"
                      stroke="currentColor"
                      strokeWidth="1.5"
                    />
                  </svg>
                </span>

                {/* COUNTRY DROPDOWN */}
                {countryOpen && (
                  <div className="absolute top-full left-0 z-50 bg-white border rounded shadow-md w-44 max-h-60 overflow-auto">
                    {countries.map((country) => (
                      <div
                        key={country._id}
                        className="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-gray-100"
                        onClick={() => {
                          setData({ ...data, country_code: country.code });
                          setCountryOpen(false);
                        }}
                      >
                        <img
                          src={getFlagImage(country.code)}
                          alt={country.name}
                          style={{ width: "20px", height: "14px" }}
                        />
                        <span className="text-sm">{country.name}</span>
                      </div>
                    ))}
                  </div>
                )}

                {/* MOBILE INPUT */}
                <input
                  type="tel"
                  value={data.mobile}
                  autoComplete="new-mobile"
                  onChange={(e) => {
                    const val = e.target.value;
                    if (/^\d{0,10}$/.test(val)) {
                      setData({ ...data, mobile: val });
                    }
                  }}
                  placeholder="Enter Your Contact Number"
                />
              </div>

              {errors.mobile && (
                <p className="text-red-500 text-xs mt-1">{errors.mobile}</p>
              )}
            </div>

            {/* Password */}
            <div>
              <label>
                Password<span className="required">*</span>
              </label>
              <div className="input-group">
                <span className="icon">
                  <img src={lockIcon} alt="lock icon" />
                </span>
                <input
                  type={showPassword ? "text" : "password"}
                  value={data.password}
                  autoComplete="new-password"
                  onChange={(e) =>
                    setData({ ...data, password: e.target.value })
                  }
                  placeholder="Enter Your Password"
                />
                <span
                  className="toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <IoEyeOffOutline className="icon" />
                  ) : (
                    <IoEyeOutline className="icon" />
                  )}
                </span>
              </div>
              {errors.password && (
                <p className="text-red-500 text-xs mt-1">{errors.password}</p>
              )}
            </div>

            {/* Confirm Password */}
            <div>
              <label>
                Confirm Password<span className="required">*</span>
              </label>
              <div className="input-group">
                <span className="icon">
                  <img src={lockIcon} alt="lock icon" />
                </span>
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Confirm Your Password"
                />
                <span
                  className="toggle"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? (
                    <IoEyeOffOutline className="icon" />
                  ) : (
                    <IoEyeOutline className="icon" />
                  )}
                </span>
              </div>
              {errors.confirmPassword && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.confirmPassword}
                </p>
              )}
            </div>
            {/* Role */}
            <div>
              <label>
                Role<span className="required">*</span>
              </label>
              <div className="input-group">
                {/* <span className="icon">
                                    <img src={lockIcon} alt="lock icon" />
                                </span> */}

                <select
                  value={data.school_role_id}
                  onChange={(e) =>
                    setData({ ...data, school_role_id: e.target.value })
                  }
                >
                  <option>Select Role</option>
                  {roles.map((e) => (
                    <option value={e._id}>{e.name}</option>
                  ))}
                </select>
              </div>
              {errors.school_role_id && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.school_role_id}
                </p>
              )}
            </div>
          </div>
          <div className="w-full flex justify-center gap-3 mb-2 mt-4">
            <button
              type="submit"
              className="button-field-primary"
              style={{ width: "30%" }}
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddAdmin;
